import { JetView, plugins } from 'webix-jet';
import { devConfig } from 'config/config';

/**
 * Class representing the bet shop management view.
 * @extends JetView
 */
export default class betShopManagementView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const theme = this.app.config.theme;
        return {
            type: 'wide',
            cols: [
                {
                    localId: 'inner:layout',
                    type: 'wide',
                    rows: [
                        {
                            view: 'toolbar',
                            css: theme,
                            elements: [
                                {
                                    width: 30,
                                    css: 'back-button',
                                    view: 'button',
                                    type: 'icon',
                                    icon: 'wxi-angle-left',
                                    id: 'security.adminuser',
                                    align: 'center',
                                    // Navigates back to the bet shop view
                                    click: () => {
                                        this.show('../betShop');
                                    },
                                },
                                {
                                    css: 'user-selected',
                                    view: 'label',
                                    id: 'lblTittle',
                                    align: 'center',
                                },
                            ],
                        },
                        {
                            view: 'tabbar',
                            localId: 'tabbar',
                            id: 'menu',
                            height: 35,
                            options: [],
                        },
                        { $subview: true },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        const _ = this.app.getService('locale')._;
        this.use(plugins.Menu, this.$$('tabbar'));
        const cur_user = this.getParam('user', true);

        // Event listener for person selection
        this.on(this.app, 'person:select', (person) => {
            this.setParam('user', person.id, true);
        });

        var vthis = this;

        // Event listener for title update
        this.on(this.app, 'title:betShop', (param) => {
            webix.delay(
                function () {
                    webix
                        .ajax()
                        .get(devConfig.geturlApi() + 'Client/GetClientById', 'id=' + vthis.getParam('user', true), {
                            // Error handling for AJAX request
                            error: function (text, data, XmlHttpRequest) {
                                webix.message('Error! ');
                            },
                            // Success handling for AJAX request
                            success: function (text, data, XmlHttpRequest) {
                                data = JSON.parse(text);
                                if (data[0].Type == 'PUNTOVENTA') {
                                    $$('lblTittle').setValue(
                                        "<div class='username-active'><span class='webix_icon webix_sidebar_icon icon-shop'></span><div style='font-weight: normal'>" +
                                            _('Punto de Venta:') +
                                            ' &nbsp;</div><div>' +
                                            data[0].Name +
                                            '</div></div>',
                                    );
                                } else {
                                    if (data[0].Type == 'CAJERO') {
                                        $$('lblTittle').setValue(
                                            "<div class='username-active'><span class='webix_icon webix_sidebar_icon icon-shop'></span><div style='font-weight: normal'>" +
                                                _('Cajero:') +
                                                ' &nbsp;</div><div>' +
                                                data[0].Name +
                                                '</div></div>',
                                        );
                                    }
                                }
                            },
                        });
                },
                '',
                '',
                1000,
            );
        });

        // Trigger the title update event
        this.app.callEvent('title:betShop', [{}]);

        // AJAX request to get user menu
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + '/Menus/GetMenuUser', '{"Menu":"betShop","id":"' + cur_user + '"}', {
                // Error handling for menu AJAX request
                error: function (text, data, XmlHttpRequest) {
                    webix.message(_('Error! '));
                },
                // Success handling for menu AJAX request
                success: function (text, data, XmlHttpRequest) {
                    var menu = JSON.parse(text);
                    menu.data.forEach(function (obj) {
                        obj.value = _(obj.value);
                    });
                    $$('menu').define('options', menu.data);
                    $$('menu').refresh();
                },
            });
    }
}

// FILE DOCUMENTED
